"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var BonusTournamentsLocalesEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentsLocalesEditor, _super);
    function BonusTournamentsLocalesEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentsLocalesEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    title: _item.title,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Шаблоны локализаций турнира", "Редактирование шаблона локализации"]);
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                title: "",
                is_fullscreen: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Шаблоны локализаций турнира", "Создание шаблона локализации"]);
            });
        }
        this.doReSetRules();
    };
    BonusTournamentsLocalesEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            title_rules: { isError: false }
        });
    };
    BonusTournamentsLocalesEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({
                app_language_rules: { isError: true, errorMessage: "Язык не выбран!" }
            });
            return false;
        }
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Название турнира не заполнено!" }
            });
            return false;
        }
        return true;
    };
    BonusTournamentsLocalesEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация шаблона турнира изменена!");
            });
        }
    };
    BonusTournamentsLocalesEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                bonus_tournament_id: this.props.rootRecord.key,
                title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация шаблона турнира добавлена!");
            });
        }
    };
    BonusTournamentsLocalesEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentsLocalesEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая локализация турнира";
        }
        else {
            return "Изменить локализацию турнира";
        }
    };
    BonusTournamentsLocalesEditor.prototype.getActionButtons = function () {
        var bTitle = { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" };
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: bTitle, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentsLocalesEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", { style: {
                minHeight: "400px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguages, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название турнира:", placeholder: "Введите название турнира" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            this.getActionButtons()));
    };
    BonusTournamentsLocalesEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400, customHeight: 'calc( 100vh - 300px )' }, this.getMainEditContent()));
    };
    return BonusTournamentsLocalesEditor;
}(React.Component));
exports.default = BonusTournamentsLocalesEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/locales/BonusTournamentsLocalesEditor.tsx
// module id = 2520
// module chunks = 0